import NotificationBadge, {
  NotificationBadgeOpts,
} from 'src/game/components/shared/NotificationBadge';
import { whileInHierarchy } from 'src/lib/utils';
import { updateTeamNotificationBadge } from '../team.utils';

export default class TeamChatNotificationBadge extends NotificationBadge {
  constructor(opts: NotificationBadgeOpts) {
    super(opts);
    this.hide();
    void whileInHierarchy(this, (stop) =>
      updateTeamNotificationBadge(stop, this),
    );
  }
}
